import { render, staticRenderFns } from "./GroupsManagementViewTest.vue?vue&type=template&id=450eff27&scoped=true"
import script from "./GroupsManagementViewTest.vue?vue&type=script&lang=js"
export * from "./GroupsManagementViewTest.vue?vue&type=script&lang=js"
import style0 from "./GroupsManagementViewTest.vue?vue&type=style&index=0&id=450eff27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450eff27",
  null
  
)

export default component.exports